import { useTranslation } from 'react-i18next'
import { useWindowDimensions, View } from 'react-native'
import { Icon } from '@/components/ui/Icon'
import { Text } from '@/components/ui/Text'
import { useTheme, useThemeColors } from '@/contexts/ThemeContext'

type Props = {
  className?: string
}

export default function CurrencyNotice({ className }: Props) {
  const { t } = useTranslation()
  const { isDark } = useTheme()
  const colors = useThemeColors()
  const { width } = useWindowDimensions()
  const isDesktop = width >= 768

  return (
    <View
      className={`rounded-xl border px-3 py-2.5 ${className ?? ''}`}
      style={{
        borderColor: colors.border,
        backgroundColor: isDark ? '#000000' : '#ffffff',
        width: isDesktop ? undefined : '100%',
        maxWidth: isDesktop ? 420 : undefined,
      }}
    >
      <View className="flex-row items-center gap-2">
        <Icon name="info-circle" size={12} color={colors.muted} />
        <Text className="flex-1 text-xs leading-[18px]" style={{ color: colors.muted }}>
          {t('common.currencyAudNotice')}
        </Text>
      </View>
    </View>
  )
}
